import {
    ALPHANUMERIC_AND_NUMBER_VALIDATION,
    ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION, ALPHANUMERIC_DASH_AND_DOT_VALIDATION,
    OCCUPATION_VALIDATION,
    ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
    ONLY_ALPHABETICAL_PATTERN_VALIDATION,
    PREVIEW_DOC_TYPES
} from "./Constants";

/**
 * Prevent typing non-numeric characters
 * @param evt
 */
const isNumber = (evt: any) => {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && charCode < 48) || charCode > 57) {
        if (charCode === 46 && evt.target.value.indexOf(".") === -1) {
            return;
        }
        evt.preventDefault();
    }
}

const isNumberWithDash = (evt: any) => {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && charCode < 48) || charCode > 57) {
        if (charCode === 45 && evt.target.value.indexOf("-") === -1) {
            return;
        }
        evt.preventDefault();
    }
};

const isNumberWithDashAndDot = (evt: any) => {
    evt = evt || window.event;
    let charCode = evt.which || evt.keyCode;

    // Allow dash (-) if it's not already present in the input
    if (charCode === 45 && evt.target.value.indexOf("-") === -1) {
        return;
    }

    // Allow decimal point (.) if it's not already present in the input
    if (charCode === 46 && evt.target.value.indexOf(".") === -1) {
        return;
    }

    // Prevent any character that is not a number (0-9)
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
    }
};

/**
 *  Prevent typing non-numeric characters without dot
 * @param evt
 */
const isNumberWithoutDot = (evt: any) => {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
    }

}

const isNumbersAndLetters = (evt: any) => {
    let keycode = evt.which || evt.keyCode;

    // Check if key pressed is a special character
    if (keycode < 48 ||
        (keycode > 57 && keycode < 65) ||
        (keycode > 90 && keycode < 97) ||
        keycode > 122
    ) {
        // Restrict the special characters
        evt.preventDefault();
        return false;
    }

}

const onlyUpperCase = (evt: any) => {
    if (!evt.key.match(/^[A-Z ]*$/)) {
        evt.preventDefault();
    }
}

const onlyAlphabeticWithSpace = (evt: any) => {
    if (!evt.key.match(ONLY_ALPHABETICAL_PATTERN_VALIDATION)) {
        evt.preventDefault();
    }
}

const onlyAlphabeticWithSpaceAndNumbers = (evt: any) => {
    if (!evt.key.match(ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION)) {
        evt.preventDefault();
    }
}
const onlyAlphabeticWithSpaceAndDot = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z. ]*$/)) {
        evt.preventDefault();
    }
}

const onlyAlphabetic = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z]*$/)) {
        evt.preventDefault();
    }
}

const alphanumericAndSpecificSpecialCharacters = (evt: any) => {
    if (!evt.key.match(ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION)) {
        evt.preventDefault();
    }
}

const alphanumericDashAndDotCharacters = (evt: any) => {
    if (!evt.key.match(ALPHANUMERIC_DASH_AND_DOT_VALIDATION)) {
        evt.preventDefault();
    }
}
const alphanumericAndSpecificSpecialCharactersForUsername = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z0-9_.\-@+]+$/)) {
        evt.preventDefault();
    }
}
const alphanumericAndSpecialCharactersForOccupation = (evt: any) => {
    if (!evt.key.match(OCCUPATION_VALIDATION)) {
        evt.preventDefault();
    }
}
const alphanumericAndNumbers = (evt: any) => {
    if (!evt.key.match(ALPHANUMERIC_AND_NUMBER_VALIDATION)) {
        evt.preventDefault();
    }
}
const emailFieldValidation = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z0-9._@\-]+$/)) {
        evt.preventDefault();
    }
}

const passwordFieldValidation = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z0-9!@#$%^&*_]+$/)) {
        evt.preventDefault();
    }
}

const  nicFieldValidation = (evt: any) => {
    if (!evt.key.match(/^[vVxX0-9]+$/)) {
        evt.preventDefault();
    }
}

const calenderDateValidation = (evt: any) => {
    if (!evt.key.match(/^[0-9\-]+$/)) {
        evt.preventDefault();
    }
}

const referenceFieldValidation = (evt: any) => {
    if (!evt.key.match(/^[a-zA-Z0-9]+$/)) {
        evt.preventDefault();
    }
}
const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

    if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
        return PREVIEW_DOC_TYPES.IMAGE;
    } else {
        return PREVIEW_DOC_TYPES.PDF;
    }

};

const Validation = {
    isNumber,
    isNumberWithDash,
    isNumberWithoutDot,
    isNumberWithDashAndDot,
    alphanumericAndNumbers,
    isNumbersAndLetters,
    onlyUpperCase,
    onlyAlphabeticWithSpace,
    onlyAlphabeticWithSpaceAndNumbers,
    alphanumericAndSpecificSpecialCharacters,
    onlyAlphabetic,
    alphanumericAndSpecificSpecialCharactersForUsername,
    onlyAlphabeticWithSpaceAndDot,
    alphanumericAndSpecialCharactersForOccupation,
    emailFieldValidation,
    passwordFieldValidation,
    nicFieldValidation,
    calenderDateValidation,
    referenceFieldValidation,
    checkDocumentContentType,
    alphanumericDashAndDotCharacters,
};


export default Validation;